import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './containers/App';
// import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import store, { history } from './store';

import '@imprivata/common-auth-ui/build/common-auth-ui.css';
import '@imprivata/nucleus/build/nucleus.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <HistoryRouter history={history}>
      <App />
    </HistoryRouter>
  </Provider>
);

// registerServiceWorker();
